import SDAU from '@/utils/SDAU'

export function getToken() {
  return SDAU.storageGet('token')
}
export function setToken(token) {
  return SDAU.storageSet({ token })
}
export function setUserinfo(userinfo) {
  return SDAU.storageSet({ userinfo })
}
export function getUserinfo() {
  return SDAU.storageGet('userinfo')
}
export function removeToken() {
  return SDAU.storageRemove('token')
}
export function removeUserinfo() {
  return SDAU.storageRemove('userinfo')
}

